import { ContextHolder } from '@frontegg/react';

export function logout() {
  const baseUrl = ContextHolder.getContext().baseUrl;
  const redirectURL = window.location.origin + window.location.pathname;
  window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${redirectURL}`;
}
